<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      nameMap: {
        sf: '实发薪资',
        yf: '应发薪资',
        cb: '人力成本'
      }
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      const seriesName = chartData.params && chartData.params.type ? this.nameMap[chartData.params.type] : '';
      const seriesData = chartData.v_92740014.length ? chartData.v_92740014.map(item => item.detailValue) : [0, 0, 0, 0, 0]
      this.chart.setOption({
        backgroundColor: '#FFFFFF',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: 25,
          left: 40,
          right: 40,
          bottom: 20,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [`10%${ this.$t('quantile') }`,`25%${ this.$t('quantile') }`,`50%${ this.$t('quantile') }`,`75%${ this.$t('quantile') }`,`90%${ this.$t('quantile') }`]
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: seriesName,
            type: 'line',
            smooth: true,
            areaStyle: {
              // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#3371C5' // 0% 处的颜色
                }, {
                  offset: 1, color: '#FFFFFF' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#3371C5'
            },
            data: seriesData
          }
        ]
      })
    }
  }
}
</script>
